module.exports = file => () => import('@/layout/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/_import_production.js